import React from 'react';
import { CheckWhiteIcon, FileIcon, PDFIcon } from 'assets/icons';

interface DocBoxProps {
  label: string;
  file?: string;
  fileName?: string;
  canDownload?: boolean;
  isPDF: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const DocBox = ({ label, file, fileName, onChange, canDownload = false, isPDF }: DocBoxProps) => {
  const downloadFile = () => {
    if (!file || !canDownload) return;
    const link = document.createElement('a');
    link.href = file;
    link.download = 'document.pdf';
    link.target = '_blank';
    link.click();
    link.remove();
  }

  return (
    <label onClick={downloadFile}>
      <label>{ label }</label>
      <div className="doc-box">
        {!!file && !isPDF && (
          <img className="document" src={file} alt="Documento" />
        )}
        {!!file && isPDF && (
          <img className="document pdf" src={PDFIcon} alt="Documento" />
        )}
        {!file && (
          <img className="document empty" src={FileIcon} alt="Documento" />
        )}
        <p>{ fileName }</p>
        {!!file && (
          <div className="checked">
            <img src={CheckWhiteIcon} alt="Uploaded" />
          </div>
        )}
      </div>
      {onChange && (
        <input type="file" accept="image/*, application/pdf" hidden onChange={onChange} />
      )}
    </label>
  )
}